const path = require("path");

module.exports = {
  i18n: {
    locales: ["de", "en"],
    defaultLocale: "de",
    domains: [
      {
        domain: "fotoboxguru.de",
        defaultLocale: "de",
        locales: ["de"],
      },
      {
        domain: "boothscanner.com",
        defaultLocale: "en",
        locales: ["en"],
      },
    ],
    localeDetection: false, // ✅ kein /de oder /en automatisch anhängen
  },
  localePath: path.resolve("./public/locales"), // 🔥 das ist der Unterschied
};
